// extracted by mini-css-extract-plugin
export default {"main":"App_main__5VZ13","map":"App_map__TFHXK"};